// internal/ApprovalsPage.jsx — Approval Engine (JSONFIRST) : actions sensibles, confirmation humaine, historique.
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import InternalLayout, { S, IT } from "@/internal/InternalLayout";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/internal`;
const H = () => ({ "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("civ_user_token") || ""}` });
const STATUS = {
  pending: { l: "En attente", c: "#F59E0B" }, executed: { l: "Exécutée", c: "#2EE27B" }, rejected: { l: "Rejetée", c: "#F87171" },
};
const TYPE = {
  workspace_create: "⚡ Création de workspace", workspace_deactivate: "🗑 Désactivation de workspace", handover_transfer: "🛟 Transfert de responsabilités",
};

export default function ApprovalsPage() {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => {
    fetch(`${API}/approvals`, { headers: H() }).then((r) => r.json()).then((d) => setRows(d.ok ? d.approvals : [])).catch(() => setRows([]));
  }, []);
  useEffect(() => { load(); }, [load]);

  const decide = async (id, decision) => {
    const r = await fetch(`${API}/approvals/${id}/decide`, { method: "POST", headers: H(), body: JSON.stringify({ decision }) });
    const d = await r.json();
    if (d.ok) { toast.success(decision === "approve" ? "✅ Action approuvée et exécutée" : "Action rejetée"); load(); }
    else toast.error(d.error);
  };

  const pending = (rows || []).filter((a) => a.status === "pending");
  const history = (rows || []).filter((a) => a.status !== "pending");

  return (
    <InternalLayout title="Sécurité & Approbations" subtitle="Aucune action critique n'est exécutée sans confirmation humaine (couche JSONFIRST).">
      <div style={{ ...S.card, padding: 16, marginBottom: 14 }} data-testid="approvals-pending">
        <h2 style={{ ...S.h2, color: "#F59E0B", marginBottom: 10 }}>⏳ En attente de votre décision ({pending.length})</h2>
        {rows == null && <div style={{ fontSize: 12.5, color: IT.muted }}>Chargement…</div>}
        {rows != null && pending.length === 0 && <div style={{ fontSize: 12.5, color: IT.muted }}>Aucune action en attente.</div>}
        {pending.map((a) => (
          <div key={a.approval_id} data-testid={`approval-${a.approval_id}`} style={{ padding: "11px 0", borderBottom: "1px solid rgba(255,255,255,0.05)", display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <span style={{ flex: 1, minWidth: 200 }}>
              <span style={{ display: "block", fontSize: 13, fontWeight: 800 }}>{TYPE[a.action_type] || a.action_type}</span>
              <span style={{ fontSize: 11.5, color: IT.muted }}>{a.intent} · demandé par {a.requested_by} · {new Date(a.created_at).toLocaleString("fr-FR")}</span>
            </span>
            <button data-testid={`approval-reject-${a.approval_id}`} onClick={() => decide(a.approval_id, "reject")}
              style={{ ...S.ghost, borderColor: "rgba(248,113,113,0.4)", color: "#F87171", background: "rgba(248,113,113,0.06)" }}>✕ Rejeter</button>
            <button data-testid={`approval-approve-${a.approval_id}`} onClick={() => decide(a.approval_id, "approve")} style={S.btn}>✓ Approuver & exécuter</button>
          </div>
        ))}
      </div>

      <div style={{ ...S.card, padding: 16 }} data-testid="approvals-history">
        <h2 style={{ ...S.h2, marginBottom: 10 }}>📜 Historique</h2>
        {history.length === 0 && <div style={{ fontSize: 12.5, color: IT.muted }}>Aucune action tracée.</div>}
        {history.map((a) => {
          const st = STATUS[a.status] || { l: a.status, c: IT.muted };
          return (
            <div key={a.approval_id} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 12, padding: "7px 0", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
              <span style={{ flex: 1, minWidth: 0 }}>
                <strong>{TYPE[a.action_type] || a.action_type}</strong>
                <span style={{ display: "block", color: IT.muted, fontSize: 11 }}>{a.intent || "—"} {a.result ? `· ${a.result}` : ""}</span>
              </span>
              <span style={{ fontSize: 9.5, fontWeight: 900, color: st.c, border: `1px solid ${st.c}55`, borderRadius: 999, padding: "2px 9px", whiteSpace: "nowrap" }}>{st.l}</span>
              <span style={{ color: IT.muted, fontSize: 11, whiteSpace: "nowrap" }}>{new Date(a.decided_at || a.created_at).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</span>
            </div>
          );
        })}
      </div>
    </InternalLayout>
  );
}
